import React from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import { NoticeListItem } from "../../../../../service/notice";
import moment from "moment";
import { Tooltip } from "antd";

interface ListItemProps {
    active: boolean;
    data: NoticeListItem;
    onClick: () => void;
    onShowReadCount: () => void;
}

export default function ListItem({
    active,
    data,
    onClick,
    onShowReadCount
}: ListItemProps) {
    return (
        <div className={classNames(style.root, { [style.open]: active })}>
            <div className={style.info}>
                <span className={style.count} onClick={onShowReadCount}>
                    已读 {data.readCount}/{data.needReadCount}
                </span>
                <div className={style.time}>
                    {moment(data.createTime).format("yyyy-MM-DD HH:mm:ss")}
                </div>
            </div>

            <div className={style.head} onClick={onClick}>
                <h1 className={style.title}>{data.title}</h1>
            </div>

            <div className={style.target}>
                <Tooltip
                    title={data.students}
                    overlayClassName={style.tooltip}
                    placement="bottomLeft">
                    <div className={style.targetWrapper}>
                        通知范围： {data.students}
                    </div>
                </Tooltip>
            </div>

            <div
                className={style.body}
                dangerouslySetInnerHTML={{
                    __html: `通知内容： ${data.content}`
                }}
            />
        </div>
    );
}
